import React from "react"
import AccessDenied from "../components/pages/AccessDenied"
import useWorkspaceAccess from "../components/hooks/workspace/useWorkspaceAccess"

type WorkspaceAccessGuardProps = {
  allowed: (access: ReturnType<typeof useWorkspaceAccess>) => boolean
  children: JSX.Element
  title?: string
  message?: string
}

const WorkspaceAccessGuard: React.FC<WorkspaceAccessGuardProps> = ({
  allowed,
  children,
  title,
  message,
}) => {
  const access = useWorkspaceAccess()

  if (access.isLoading) {
    return <></>
  }

  if (!allowed(access)) {
    return <AccessDenied title={title} message={message} />
  }

  return children
}

export default WorkspaceAccessGuard
